<div class="embedded-module-page">
    <!-- Error al renovar: el iframe existente sigue visible, no se pierde el contexto -->
    <div *ngIf="renewalError" class="renewal-error mb-3">
        <p class="text-warning mb-1">{{ renewalError }}</p>
        <button mat-button color="primary" (click)="retryRenewal()">
            Reintentar
        </button>
    </div>

    <!-- Cargando token inicial -->
    <div
        *ngIf="loading"
        class="iframe-container iframe-loading d-flex align-items-center justify-content-center"
    >
        <mat-spinner diameter="40"></mat-spinner>
        <span class="ms-2">Obteniendo acceso a {{ moduleTitle }}...</span>
    </div>

    <!-- Error al obtener el token inicial: no hay nada que mostrar todavía -->
    <div
        *ngIf="!loading && loadError"
        class="iframe-container load-error d-flex flex-column align-items-center justify-content-center"
    >
        <p class="text-warning mb-2">{{ loadError }}</p>
        <button mat-button color="primary" (click)="retryLoad()">
            Reintentar
        </button>
    </div>

    <!-- iframe con el módulo externo: sin título, sin link ni recuadro, solo el contenido -->
    <div *ngIf="!loading && !loadError && safeUrl" class="iframe-container">
        <iframe
            [src]="safeUrl"
            [title]="moduleTitle"
            class="embedded-module-iframe"
        ></iframe>
    </div>
</div>
